import React,{useState,useRef} from 'react'
import Box from '@mui/material/Box';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import './Form.css'
import FormInput from './FormInput';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import BadgeIcon from '@mui/icons-material/Badge';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import AssuredWorkloadOutlinedIcon from '@mui/icons-material/AssuredWorkloadOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import firebase from '../Firebase';
import { db } from '../Firebase';
import { ContentCutOutlined } from '@mui/icons-material';
import { StraightenRounded } from '@material-ui/icons';
var str=""
var str1=""
function Form() {
   function handleGenerate(){
      str=""
      // str="HZ22"+hid
      // setHoid(hid);
      // str= "HZ22"+new Date().getTime().toString();
      // console.log(str);
      str=new Date().getTime().toString();
      
      str1=str.slice(5,13);
      str1="HZ22"+str1
      console.log(str1)
   };
const[name,setName]=useState("")
const[roll,setRoll]=useState("");
const[email,setEmail]=useState("");
const[tel,setTel]=useState("");
const[dept,setDept]=useState("");
const[year,setYear]=useState("");
const[want,setWant]=useState(false);
const[size,setSize]=useState("");
const[robo,setRobo]=useState(false);
const[Treas,setTreas]=useState(false);
const[elecq,setElecq]=useState(false);
const[pra,setPra]=useState(false);
const[techq,setTechq]=useState(false);
const[ctrix,setCtrix]=useState(false);
const[papy,setPapy]=useState(false);
const[webd,setWebd]=useState(false);
const[wannac,setWannac]=useState(false);
const[hackm,setHackm]=useState(false);
const[dtd,setDtd]=useState(false);
const[autoc,setAutoc]=useState(false);
const[mechq,setMechq]=useState(false);
const[brug,setBrug]=useState(false);
const[autow,setAutow]=useState(false);
const[embed,setEmbed]=useState(false);
const[cine,setCine]=useState(false);
const[photog,setPhotog]=useState(false);
const[hoid,setHoid]=useState("");
const[got,setGot]=useState(false);
const[bp,setBp]=useState(false);
const[ppt,setPpt]=useState(false);

// console.log(name);
function downl(){
   const element=document.createElement("a")
   const file=new Blob([`  
   Hii ${name}
   Your Details Have Been Submitted Successfully✌
   Your Horizon Id is: ${str1} 
   Use the horizon id to pay registration fee and for future references.

   Team HORIZON
   BCREC Durgapur
   `],{
      type:"text/plain;charset=utf-8",
   });
   element.href=URL.createObjectURL(file);
   element.download="YourHorizonId.txt"
   element.click()
};

const handleSubmit = (e) =>{
   handleGenerate();
   downl();
   e.preventDefault();
   db.collection("Details").add({
      Name: name,
      UniversityRollNo: roll,
      Email: email,
      PhoneNumber: tel,
      Department: dept,
      Year: year,
      TshirtRequirment: want,
      Size: size,
      RoboTrix: robo,
      TreasureHunt: Treas,
      Cinetrix:cine,
      Photography:photog,
      ElectronicsQ: elecq,
      Pradarshan: pra,
      Techquiz: techq,
      Circuitrix: ctrix,
      Papyrus: papy,
      Webd: webd,
      Wannacode: wannac,
      HackMaze: hackm,
      DareToDebug: dtd,
      AutoCad: autoc,
      MechQuiz: mechq,
      HorizonId: str1,
      BrugIt: brug,
      AutoCadWorkShop: autow,
      EmbedIt: embed,
      GameOfThrones:got,
      BPlan:bp,
      PptTechnicalIdea:ppt,
   })
   .then(()=>{
      alert(`  
      Hii ${name}
      Your Details Have Been Submitted Successfully✌
      Your Horizon Id is: ${str1} 
      Use the horizon id to pay registration fee and for future references.

      Team HORIZON
      BCREC Durgapur
      `)
   })
   .catch((error)=>{
      alert(error.message);
   });
  setName('')
  setRoll('')
  setEmail('')
  setTel('')
  setDept('')
  setYear('')
//   setWant(false)
  setSize('')
//   setHoid('')
//   setRobo(false)
//   setTreas(false)
//   setElecq(false)
//   setPra(false)
//   setTechq(false)
//   setCtrix(false)
//   setPapy(false)
//   setWebd(false)
//   setWannac(false)
//   setHackm(false)
//   setDtd(false)
//   setAutoc(false)
//   setMechq(false)
//   setBrug(false)
//   setAutow(false)
//   setEmbed(false)
};
//db.collection('contacts')
//.add({
//   name: name,
//   roll: roll,
//   email: email,
//   tel: tel,
//   dept: dept,
//   year: year,
//   want: want,
//   size: size,
//   robo: robo,
//   Treas: Treas,
//   elecq: elecq,
//   pra: pra,
//   techq: techq,
//   ctrix: ctrix,
//   papy: papy,
//   webd: webd,
//   wannac: wannac,
//   hackm: hackm,
//   dtd: dtd,
//   autoc: autoc,
//   mechq: mechq,
//   brug: brug,
//   autow: autow,
//   embed: embed,
//});
//};
const toggle=()=>{
   setRobo(current=>!current)
   var radioB = document.querySelector("input[name='RoboTrix']");
   if(robo===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle1=()=>{
   setTreas(current=>!current)
   var radio1 = document.querySelector("input[name='Treasure-Hunt']");
   if(Treas===true){
      radio1.checked=false;
   }else{
      radio1.checked=true;
   }
}
const toggle2=()=>{
   setElecq(current=>!current)
   var radioB = document.querySelector("input[name='Electronics Quiz']");
   if(elecq===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle3=()=>{
   setPra(current=>!current)
   var radioB = document.querySelector("input[name='Pradarshan']");
   if(pra===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle4=()=>{
   setTechq(current=>!current)
   var radioB = document.querySelector("input[name='Tech Quiz']");
   if(techq===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle5=()=>{
   setCtrix(current=>!current)
   var radioB = document.querySelector("input[name='CircuiTrix']");
   if(ctrix===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle6=()=>{
   setPapy(current=>!current)
   var radioB = document.querySelector("input[name='Papyrus']");
   if(papy===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle7=()=>{
   setWebd(current=>!current)
   var radioB = document.querySelector("input[name='Web-D']");
   if(webd===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle8=()=>{
   setWannac(current=>!current)
   var radioB = document.querySelector("input[name='WannaCode']");
   if(wannac===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle9=()=>{
   setHackm(current=>!current)
   var radioB = document.querySelector("input[name='HackMaze']");
   if(hackm===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle10=()=>{
   setDtd(current=>!current)
   var radioB = document.querySelector("input[name='Dare To Debug']");
   if(dtd===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle11=()=>{
   setAutoc(current=>!current)
   var radioB = document.querySelector("input[name='AutoCAD']");
   if(autoc===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle12=()=>{
   setMechq(current=>!current)
   var radioB = document.querySelector("input[name='Mech Quiz']");
   if(mechq===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle13=()=>{
   setBrug(current=>!current)
   var radioB = document.querySelector("input[name='Brug It']");
   if(brug===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle14=()=>{
   setAutow(current=>!current)
   var radioB = document.querySelector("input[name='AutoCAD Workshop']");
   if(autow===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}

const toggle15=()=>{
   setEmbed(current=>!current)
   var radioB = document.querySelector("input[name='Embed-IT']");
   if(embed===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle16=()=>{
   setCine(current=>!current)
   var radioB = document.querySelector("input[name='cine']");
   if(cine===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle17=()=>{
   setPhotog(current=>!current)
   var radioB = document.querySelector("input[name='photog']");
   if(photog===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle18=()=>{
   setGot(current=>!current)
   var radioB = document.querySelector("input[name='got']");
   if(got===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle19=()=>{
   setBp(current=>!current)
   var radioB = document.querySelector("input[name='bp']");
   if(bp===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggle20=()=>{
   setPpt(current=>!current)
   var radioB = document.querySelector("input[name='ppt']");
   if(ppt===true){
      radioB.checked=false;
   }else{
      radioB.checked=true;
   }
}
const toggleTshirtTrue=()=>{
   setWant(current=>true)
}
const toggleTshirtFalse=()=>{
   setWant(current=>false)
}
console.log(got);
console.log(bp);
console.log(ppt);
console.log(photog)
  return (
       <>
       <div id="form" style={{display:'flex',justifyContent:'center',background:'white' ,margin:'280px',borderRadius:'2rem', boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}}>
        <form className='main_form'>
          <div className='formInput'>
          <h1>REGISTER ASAP!</h1>
          </div>
          <div className='formInput'>
            {/* <label>
              Name
            </label> */}
            <PersonOutlinedIcon/>
            <input className="Input"placeholder='Name' type="text" value={name} onChange={(e)=>setName(e.target.value)}/>
         </div>
         <div className='formInput'>
            {/* <label>
              University Roll Number
            </label> */}
            {/* <BadgeIcon/> */}
            <BadgeOutlinedIcon/>
            <input className="Input" placeholder='University Roll No' type="number" value={roll} onChange={(e)=>setRoll(e.target.value)}></input>
         </div>
         <div className='formInput'>
            {/* <label>
              Email
            </label> */}
            <AlternateEmailOutlinedIcon/>
            <input className="Input" placeholder='Email' type="email" value={email} onChange={(e)=>setEmail(e.target.value)}></input>
          </div>
          <div className='formInput'>
            {/* <label>
              Phone Number
            </label> */}
            {/* <ContactPhoneOutlinedIcon/> */}
            <PhoneAndroidOutlinedIcon/>
            <input className="Input" placeholder='Phone Number' type="tel" value={tel} onChange={(e)=>setTel(e.target.value)}></input>
          </div>
          <div className='formInput'>
            {/* <label>
              Dept
            </label> */}
            <AssuredWorkloadOutlinedIcon/>&nbsp;
            <select value={dept} onChange={(e)=>setDept(e.target.value)}>
            <option value="" disabled selected>Department</option>
              <option value="ECE">ECE</option>
              <option value="CSE">CSE</option>
              <option value="IT">IT</option>
              <option value="EE">EE</option>
              <option value="CE">CE</option>
              <option value="AEIE">AEIE</option>
              <option value="ME">ME</option>
              <option value="CSD">CSD</option>
              <option value="AIML">AIML</option>
              <option value="Others">Others</option>
            </select>
          </div>
          <div className='formInput'>
            {/* <label>
              Year
            </label> */}
            <SchoolOutlinedIcon/>&nbsp;
            <select value={year} onChange={(e)=>setYear(e.target.value)}>
            <option value="" disabled selected>Year</option>
              <option value="1st">1st</option>
              <option value="2nd">2nd</option>
              <option value="3rd">3rd</option>
              <option value="4th">4th</option>
            </select>
          </div>
          <div>
  
          </div>
          <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
            <h3>Do You Want A Horizon T-Shirt</h3>
         </div>
         
         <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
            <input type="radio" name="T-Shirt" value={want} onChange={toggleTshirtTrue}/>Yes
         </div>
         <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
            <input type="radio" name="T-Shirt" alue={want} onChange={toggleTshirtFalse}/>No
         </div>
         <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
         <select value={size} onChange={(e)=>setSize(e.target.value)}>
            <option value="" disabled selected>(If Yes) Size Of T-Shirt</option>
              <option value="small">Small(S)</option>
              <option value="medium">Medium(M)</option>
              <option value="large">Large(L)</option>
              <option value="xlarge">Extra Large(XL)</option>
              <option value="xxlarge">Extra Extra Large(XXL)</option>
            </select>
         </div>
         <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
         <h3>Select The Events You are Interested In</h3>
         </div>
         <div className="Event">
         <div >
            <input type="radio" name="Treasure-Hunt" value={Treas} onClick={toggle1}/>Treasure Hunt
         </div>
         <div >
            <input type="radio" name="cine" value={cine} onClick={toggle16}/>CineTrix
         </div>
         <div >
            <input type="radio" name="photog" value={photog} onClick={toggle17}/>Photography
         </div>
         <div >
            <input type="radio" name="got" value={photog} onClick={toggle18}/>Game Of Thrones
         </div>
         <div >
            <input type="radio" name="bp" value={photog} onClick={toggle19}/>B-Plan
         </div>
         <div >
            <input type="radio" name="RoboTrix" value={robo} onClick={toggle}/>RoboTrix
         </div>
         <div >
            <input type="radio" name="Pradarshan" value={pra} onClick={toggle3}/>Pradarshan
         </div>
         <div >
            <input type="radio" name="ppt" value={photog} onClick={toggle20}/>Ppt Presentation (Technical Idea)
         </div>
         <div >
            <input type="radio" name="Electronics Quiz" value={elecq} onClick={toggle2}/>Electronics Quiz
         </div>
         <div >
            <input type="radio" name="Tech Quiz" value={techq} onClick={toggle4}/>Tech Quiz
         </div>
         <div >
            <input type="radio" name="CircuiTrix" value={ctrix} onClick={toggle5}/>CircuiTrix
         </div>
         <div >
            <input type="radio" name="Papyrus" value={papy} onClick={toggle6}/>Papyrus
         </div>
         <div >
            <input type="radio" name="Web-D" value={webd} onClick={toggle7}/>Web-D
         </div>
         <div >
            <input type="radio" name="WannaCode" value={wannac} onClick={toggle8}/>WannaCode
         </div>
         <div >
            <input type="radio" name="HackMaze" value={hackm} onClick={toggle9}/>HackMaze
         </div>
         <div >
            <input type="radio" name="Dare To Debug" value={dtd} onClick={toggle10}/>Dare To Debug
         </div>
         <div >
            <input type="radio" name="AutoCAD" value={autoc} onClick={toggle11}/>AutoCAD
         </div>
         <div >
            <input type="radio" name="Mech Quiz" value={mechq} onClick={toggle12}/>Mech Quiz
         </div>
         <div >
            <input type="radio" name="Brug It" value={brug} onClick={toggle13}/>Brug It
         </div>
         <div >
            <input type="radio" name="AutoCAD Workshop" value={autow} onClick={toggle14}/>AutoCAD Workshop
         </div>
         <div >
            <input type="radio" name="Embed-IT" value={embed} onClick={toggle15}/>Embed-IT
         </div>
         {/* <div className="but">
      <Button variant="contained" color="primary" style={{boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.2)'}} onClick={handleGenerate()}>
        Generate Horizon Id
      </Button>
      <div>
         <h1>hi id</h1>
      </div> */}
      
         <div className="but">
      <Button variant="contained" color="secondary" style={{boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}} onClick={handleSubmit} >
        Register!
      </Button>
      </div>
         </div>
            </form>
        </div>
       </>
  );
}

export default Form